import { ICarrierSchema } from './carrier-schema.interface';
import { ITachographInformationSchema } from './tachograph-information-schema.interface';
import { ITagsSchema } from './tags-schema.interface';
import { ExternalDriverAllowedActions } from '../../enums';
import { IDriverDeviceOutputDto } from '../driver-device-output-dto.interface';

export interface IDriverAssociatedOrganizations {
    organizationId: string;
    orgLocalName: string;
    orgLocalId: string;
}

export interface IDriverSchema {
    id: string;
    organizationId: string;
    name: string;
    surname: string;
    fullName?: string;
    nationalId: string;
    carrier: ICarrierSchema;
    inDuty?: boolean;
    code?: string | null;
    externalId?: string | null;
    licenseNumber?: string | null;
    phoneNumber: string;
    status?: string | null;
    assignedVehicle?: string | null;
    assignedVehicleLicensePlate?: string | null;
    photo?: string | null;
    tags?: string[] | ITagsSchema[] | null;
    invitationLink?: string;
    updatedAt?: string;
    createdAt?: string;
    hasDevice?: boolean;
    device?: IDriverDeviceOutputDto;
    tachographData?: ITachographInformationSchema;
    isExternal?: boolean;
    orgsWithFullAccess?: IDriverAssociatedOrganizations[];
    orgsCanInviteToApp?: IDriverAssociatedOrganizations[];
    allowedActions?: ExternalDriverAllowedActions[];
}
